import React from "react";
import { styled } from "@mui/system";

const Ast = styled("span")`
  color: ${({ theme }) => theme.palette.error.main};
  padding-left: 6px;
`;

export const Asterisk = () => <Ast>*</Ast>;
